import { For, type JSX } from 'solid-js';

export type BatchOption = {
  id: string;
  label: string;
  isCurrent: boolean;
};

export default function BatchSelector(props: {
  batches: BatchOption[];
  selectedId: string;
  onSelect: (id: string) => void;
}): JSX.Element {
  return (
    <label class="flex flex-col gap-1 text-sm">
      <span class="font-medium">Batch</span>
      <select name="select"
        class="rounded-md border border-brand-hex bg-white px-3 py-2"
        value={props.selectedId}
        onChange={(e) => props.onSelect(e.currentTarget.value)}
      >
        <For each={props.batches}>
          {(b) => (
            <option value={b.id}>
              {b.label}
              {b.isCurrent ? ' (current)' : ''}
            </option>
          )}
        </For>
      </select>
    </label>
  );
}
